import {
	GET_BILLING_FREQUENCY_SUCCESS,
	PUT_BILLING_FREQUENCY_SUCCESS,
} from 'stash/actions/api/billingFrequency';

const updateActiveBillingFrequency = (state_billingFrequencies, billingFreqResponse) => {
	// const billingFrequencies = state.entities.billing_frequencies;
	return state_billingFrequencies.map((billingFrequency) => {
		if (billingFrequency.frequency.unit === billingFreqResponse.frequency.unit) {
			billingFrequency.active = billingFreqResponse.active;
		} else {
			billingFrequency.active = false;
		}

		return billingFrequency;
	});
};
const billing_frequencies = (state = [], action) => {
	switch (action.type) {
		case GET_BILLING_FREQUENCY_SUCCESS:
			return action.response.billingFrequencies;
		case PUT_BILLING_FREQUENCY_SUCCESS:
			return updateActiveBillingFrequency(state, action.response.billingFrequency);
		default:
			return state;
	}
};

export default billing_frequencies;
